/*
  Zentraler Klaviyo-Newsletter-Handler (site-weit via layout/theme.liquid geladen).
  Routet ALLE Newsletter-Eintritte ueber die Klaviyo Client-API mit Double-Opt-in
  (Liste WF4XTC) und haengt signup_source an. Kein Shopify-Dual-Write mehr.

  Zwei Formular-Familien:
   1) [data-brief-inline]  -> "der Brief" (Startseite/Collections via brief-browse,
      Artikel via brief-inline). Optional zweistufig (data-brief-cta). Quelle aus data-source.
   2) form.newsletter-form -> Theme-Formulare (Header-Popup, Footer, Newsletter-Section,
      Popup). Quelle aus DOM-Kontext.
*/
(function () {
  if (window.__klaviyoNewsletterInit) return;
  window.__klaviyoNewsletterInit = true;

  var SITE_ID = 'WqzWP6';
  var LIST_ID = 'WF4XTC';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function subscribe(email, source, extraProps, onOk, onErr) {
    var props = { signup_source: source };
    if (extraProps) { for (var k in extraProps) { if (extraProps[k]) props[k] = extraProps[k]; } }
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + SITE_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) { onErr(); return; }
      markSubscribed(source);
      onOk();
    }).catch(onErr);
  }

  // Merker "hat sich angemeldet" (DOI angestossen) fuer Einblendungen wie das
  // Brief-Slide-in (assets/brief-slide-in.js), die Angemeldete nicht mehr stoeren.
  function markSubscribed(source) {
    try { window.localStorage.setItem('sonsu_brief_subscribed', String(Date.now())); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('sonsu:brief-subscribed', { detail: { source: source } })); } catch (e) {}
  }

  function newsletterSource(form) {
    if (form.closest('#newsletter-popup-overlay')) return 'header-popup';
    if (form.closest('.popup-wrap')) return 'popup';
    if (form.closest('.footer')) return 'footer';
    if (form.closest('.newsletter')) return 'newsletter-section';
    return 'newsletter';
  }

  function lang() { return (document.documentElement.lang || 'de').slice(0, 2); }

  function showThemeMessage(form, ok) {
    var en = lang() === 'en';
    var txt = ok
      ? (en ? 'Almost there. Check your inbox and confirm your subscription.'
            : 'Fast geschafft. Schau in dein Postfach und bestätige deine Anmeldung.')
      : (en ? 'That did not work. Please try again later.'
            : 'Hat nicht geklappt. Bitte später noch einmal versuchen.');
    var el = form.querySelector('[data-klaviyo-msg]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-klaviyo-msg', '');
      el.className = 'newsletter-form__message form__message';
      el.setAttribute('role', 'status');
      el.style.marginTop = '1rem';
      form.appendChild(el);
    }
    el.textContent = txt;
    el.style.color = ok ? '' : '#FF0777';
    if (ok) {
      var inner = form.querySelector('.newsletter-form__inner');
      if (inner) inner.style.display = 'none';
    }
  }

  ready(function () {
    // 1) "der Brief" units (two-step or direct)
    document.querySelectorAll('[data-brief-inline]').forEach(function (unit) {
      if (unit.dataset.klaviyoBound) return; unit.dataset.klaviyoBound = '1';
      var cta = unit.querySelector('[data-brief-cta]');
      var action = unit.querySelector('[data-brief-action]');
      var form = unit.querySelector('[data-brief-form]');
      var email = unit.querySelector('[data-brief-email]');
      var success = unit.querySelector('[data-brief-success]');
      var error = unit.querySelector('[data-brief-error]');
      var submitBtn = form ? form.querySelector('[type="submit"]') : null;
      if (!form || !email) return;

      if (cta) cta.addEventListener('click', function () {
        if (action) action.hidden = true;
        form.hidden = false;
        email.focus();
      });

      var source = unit.dataset.source || 'inline-content';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var value = email.value.trim();
        if (!value) return;
        if (error) error.hidden = true;
        if (submitBtn) submitBtn.disabled = true;
        subscribe(value, source,
          { signup_article: unit.dataset.article || '', signup_cluster: unit.dataset.cluster || '' },
          function () { form.hidden = true; if (success) success.hidden = false; },
          function () { if (error) error.hidden = false; if (submitBtn) submitBtn.disabled = false; });
      });
    });

    // 2) Theme newsletter forms (Shopify-Customer-Markup) -> Klaviyo DOI, kein Shopify-Submit
    document.querySelectorAll('form.newsletter-form').forEach(function (form) {
      if (form.closest('[data-brief-inline]')) return;     // schon oben behandelt
      if (form.dataset.klaviyoBound) return; form.dataset.klaviyoBound = '1';
      var email = form.querySelector('input[type="email"]');
      if (!email) return;
      var submitBtn = form.querySelector('[type="submit"]');
      var source = newsletterSource(form);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var value = email.value.trim();
        if (!value) return;
        if (submitBtn) submitBtn.disabled = true;
        subscribe(value, source, null,
          function () { showThemeMessage(form, true); },
          function () { showThemeMessage(form, false); if (submitBtn) submitBtn.disabled = false; });
      });
    });
  });
})();
